import { render, staticRenderFns } from "./InputDatePicker.vue?vue&type=template&id=6b880449&scoped=true"
import script from "./InputDatePicker.vue?vue&type=script&lang=js"
export * from "./InputDatePicker.vue?vue&type=script&lang=js"
import style0 from "./InputDatePicker.vue?vue&type=style&index=0&id=6b880449&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b880449",
  null
  
)

export default component.exports